import { Component, signal, computed } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { FormsModule } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ToastrModule, ToastrService } from 'ngx-toastr';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-reset-password',
  standalone: true,
  imports: [
    CommonModule,
    MatCardModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    FormsModule,
    ToastrModule 
  ],
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.css']
})
export class ResetPasswordComponent {
  senhaRegex = '^(?=.*[a-z])(?=.*[A-Z])(?=.*\\d)(?=.*[@$!%*?&])[A-Za-z\\d@$!%*?&]{8,}$';

  novaSenha = signal('');
  confirmarNovaSenha = signal('');
  token = '';

  senhasCoincidem = computed(() => this.novaSenha() === this.confirmarNovaSenha());

  constructor(
    private route: ActivatedRoute,
    private http: HttpClient,
    private router: Router,
    private toastr: ToastrService
  ) {
    this.route.queryParams.subscribe(params => {
      this.token = params['token'];
    });
  }

  resetarSenha() {
    if (!this.novaSenha() || !this.confirmarNovaSenha()) {
      this.toastr.error('Preencha todos os campos.', 'Erro');
      return;
    }

    if (!this.senhasCoincidem()) {
      this.toastr.error('As senhas nÃ£o coincidem.', 'Erro');
      return;
    }

    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });

    const payload = {
      resetToken: this.token,
      newPassword: this.novaSenha(),
      confirmNewPassword: this.confirmarNovaSenha()
    };

    this.http.post(`${environment.apiUrl}/auth/reset-password`, payload, { headers })
      .subscribe({
        next: () => {
          this.toastr.success('Senha redefinida com sucesso.');
          this.router.navigate(['/login']);
        },
        error: () => {
          this.toastr.error('Erro ao redefinir senha.', 'Erro');
        }
      });
  }
}